module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_01@2x-03d5e52f3535b031f6b6e4c44b231c24.webp";